<template>
    <transition name="dropdown">
        <div :class="dropdown ? 'dropdown-filter' : 'panel-filter'">
            <div :class="dropdown ? 'd-md-flex' : 'd-block'" v-if="hasSelection">
                <div class="alink mr-1 d-flex" v-if="filter.rating" @click="onRemove('rating')">
                    <span class="mr-2">RATING</span><b><RatingStars :value="filter.rating" /></b>
                </div>
                <div class="alink mr-1" v-if="filter.prezzo" @click="onRemove('prezzo')">
                    <span class="mr-2">PREZZO</span>
                    <b class="mr-1">&euro; {{minPriceF}}</b>-
                    <b>&euro; {{maxPriceF}}</b>
                </div>
                <div class="alink" v-if="filter.nome" @click="onRemove('nome')">
                    <span class="mr-2">NOME</span><b>{{filter.nome}}</b>
                </div>
            </div>
            <div class="bg-white">
                <form @submit.prevent>
                    <div class="form-group">
                        <label>Rating</label>
                        <div :class="isDropdown ? 'd-md-flex px-3 px-md-5 py-2 py-md-3 bg-light' : 'd-block p-3 bg-light'">
                            <div v-for="item in ratings" :key="item" class="w-100 pretty p-default p-curve">
                                <input type="radio" name="rating" :checked="filter.rating === item" @click="onSelect('rating', item)"/>
                                <div class="state p-secondary-o">
                                    <label style="text-indent: inherit; height: 0;">
                                        <RatingStars class="ratingAdjust" :value="item" />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Prezzo</label>
                        <div :class="isDropdown ? 'px-3 px-md-5 py-2 py-md-3 bg-light' : 'p-3 bg-light'">
                            <PriceRangeSlider :min-price="minPrice" :max-price="maxPrice" :value="filter.prezzo" @input="onInputPrezzo"/>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Nome</label>
                        <div :class="isDropdown ? 'px-3 px-md-5 py-2 py-md-3 bg-light' : 'p-3 bg-light'">
                            <input class="form-control" type="text" name="nome" :value="filter.nome" @input="onInputNome"/>
                        </div>
                    </div>
                    <div v-if="isMobile">
                        <button class="btn btn-primary" @click="$emit('close')">chiudi</button>
                    </div>
                </form>
            </div>
        </div>
    </transition>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import PriceRangeSlider from '../../../common/PriceRangeSlider'
import {formatMoney} from '../../../../../utils/formatter'
import RatingStars from '../../../../common/RatingStars'
import AnalyticEvents from '../../../../common/AnalyticEvents'
import MobileDetector from '../../../../common/MobileDetector'

export default {
  name: 'DropdownFilterHotel',
  mixins: [AnalyticEvents, MobileDetector],
  components: {RatingStars, PriceRangeSlider},
  props: {
    value: Object,
    list: Array,
    isDropdown: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    dropdown () {
      return this.isDropdown === true
    },
    ratings () {
      return [3, 4, 5]
    },
    filter () {
      return this.value
    },
    hasSelection () {
      return this.filter.rating || this.filter.prezzo || this.filter.nome
    },
    prices () {
      return this.list.map(item => {
        return item.venditaTotaleEuro
      })
    },
    minPrice () {
      return this.prices && this.prices.length > 0 ? this.prices.reduce((totale, current) => {
        return Math.min(totale, current)
      }) : 0
    },
    maxPrice () {
      return this.prices && this.prices.length > 0 ? this.prices.reduce((totale, current) => {
        return Math.max(totale, current)
      }) : 0
    },
    minPriceF () {
      return formatMoney(this.filter.prezzo[0])
    },
    maxPriceF () {
      return formatMoney(this.filter.prezzo[1])
    }
  },
  methods: {
    ...mapGetters(['getTypesRating']),
    ...mapActions(['modifyHotelFilter']),
    rating (rate) {
      return this.getTypesRating().find(function (item) {
        return item.type === rate
      })
    },
    onInputNome (event) {
      const { value } = event.target
      const filter = {...this.filter, nome: value}
      this.onChangeFilter(filter)
    },
    onInputPrezzo (value) {
      const filter = {...this.filter, prezzo: value}
      this.trackModaleListaHotelPrezzoMappa()
      this.onChangeFilter(filter)
    },
    onSelect (property, item) {
      const filter = {...this.filter, [property]: item}
      this.trackModaleListaHotelFiltroRating()
      this.onChangeFilter(filter)
    },
    onRemove (property) {
      const filter = {...this.filter, [property]: null}
      this.onChangeFilter(filter)
    },
    onChangeFilter: function (filter) {
      this.modifyHotelFilter(filter)
    }
  }
}
</script>

<style scoped>
    .ratingAdjust {
        position: relative;
        top: -12px;
        left: 12px;
        height: 0;
    }
</style>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/volo-hotel/dropdown/DropdownFilterHotel.vue